module.exports = __webpack_public_path__ + "img/img12.5a4010b9.png";